export default "__VITE_ASSET__CrL$Ujdd__"